import React from 'react';
import {Box} from "@mui/material";
import ReactHtmlParser from "react-html-parser";

type WidgetProps = {
    value: any;
};

const Widget: React.FC<WidgetProps> = ({value}) => {
    return (
        <Box>
            {ReactHtmlParser(value?.content)}
        </Box>
    );
};

export default Widget;
